module.exports = __webpack_public_path__ + "img/main01.c374ff7b.jpg";